import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import InfluencerContextBar from '../../components/influencer-context-bar';
import CreatorTable from '../../containers/creator-table';
import { reportError } from '../../utils/error-handling-service';

class MyCreators extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };
  static propTypes = {
    user: PropTypes.object,
  };

  static defaultProps = {
    user: null,
  };

  constructor(props) {
    super(props);

    this.state = {
      showTooltip: false,
      filter: {
        platform: 'instagram',
        min: '1000',
        max: '5000',
        country: '',
        maxInstagramEngagementRate: '',
        minInstagramEngagementRate: '1',
        hasEmail: true,
      },
      currentPage: 1,
      sort: {
        field: 'createdDate',
        order: 'DESC',
      },
      ...this.extractSearchParams(props.location),
    };
  }

  toggleShowTooltip = showTooltip => this.setState({ showTooltip });

  leftButtonCallback = () => this.context.router.push('/dashboard');

  rightButtonCallback = () => this.context.router.push('/influencer/add');

  extractSearchParams = ({ hash }) => {
    try {
      const data = JSON.parse(decodeURIComponent(hash.slice(1)));
      this.setState(data);
      return data;
    } catch (e) {
      console.error(e);
      reportError('SEARCH_PARSE_ERROR', e);

      return {};
    }
  }

  onSearchParamsChange = newParams => {
    const filter = newParams.filter || this.state.filter;
    const currentPage = newParams.currentPage || this.state.currentPage;
    const sort = newParams.sort || this.state.sort;
    const hash = JSON.stringify(({ filter, currentPage, sort }));
    const { location: { pathname } } = this.props;
    this.context.router.replace({ pathname, hash: `#${hash}` });
    this.setState(newParams);
  };


  render() {
    const { user } = this.props;
    const { filter, currentPage, sort } = this.state;
    const searchParams = { filter, currentPage, sort };

    const cacheBuster = this.props.location.query;

    const organisationName = user ? user.organisation.name : '';
    const organisationId = user ? user.organisation.id : '';
    const organisationSlug = user ? user.organisation.slug : '';
    const displayAuthorisedData = user ? user.organisation.displayAuthorisedData : false;
    const usesGlobalTags = user ? user.organisation.usesGlobalTags : false;
    return (
      <div className="page">

        <InfluencerContextBar
          organisationName={organisationName}
          showTooltip={this.state.showTooltip}
          rightButtonLabel="Add A Creator"
          leftButtonLabel="Create A Campaign"
          rightButtonCallback={_.noop}
          // rightButtonCallback={this.rightButtonCallback}
          leftButtonCallback={_.noop}
          // leftButtonCallback={this.leftButtonCallback}
          title="My Creators"
          hasPrivateLink
        />
        <div className="page-content">
          {user &&
            <CreatorTable
              usesGlobalTags={usesGlobalTags}
              organisationSlug={organisationSlug}
              organisationId={organisationId}
              displayAuthorisedData={displayAuthorisedData}
              toggleShowTooltip={this.toggleShowTooltip}
              cacheBuster={cacheBuster}
              searchParams={searchParams}
              onSearchParamsChange={this.onSearchParamsChange}
            />}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user.user,
});

export default connect(mapStateToProps)(MyCreators);



/** WEBPACK FOOTER **
 ** ./src/containers/my-creators/index.js
 **/